module.exports = __webpack_public_path__ + "img/premium-mini.27eab09b.jpg";